import { ScUtils } from 'smartcommerce-component-library'
import { isNotEmpty } from '../../shared/utils/common'

export default class VehicleDetails {
  constructor ({ id, productionYear, vehicleBrand, vehicleType, licencePlate, groupCode, packageCode }) {
    this.id = id || ScUtils.methods.generateId()
    this.productionYear = productionYear || null
    this.vehicleBrand = vehicleBrand || null
    this.vehicleType = vehicleType || null
    this.licencePlate = licencePlate || null
    this.groupCode = groupCode || null
    this.packageCode = packageCode || null
  }

  isFilled () {
    return isNotEmpty(this.productionYear) || isNotEmpty(this.vehicleBrand) || isNotEmpty(this.vehicleType) || isNotEmpty(this.licencePlate)
  }

  clear () {
    this.productionYear = null
    this.vehicleBrand = null
    this.vehicleType = null
    this.licencePlate = null
    this.packageCode = null
  }
}
